import { useEffect, useMemo, useState } from 'react';
import { useQueryParams } from '@/hooks';
import { OfficesFilter } from '../models';

const useOfficesFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: OfficesFilter = useMemo(
    () => ({
      name: '',
      cityId: '',
    }),
    []
  );

  const [filter, setFilter] = useState<OfficesFilter>(() => {
    return {
      name: getQueryParam('name') || initialFilter.name,
      cityId: getQueryParam('cityId') || initialFilter.cityId,
    };
  });

  useEffect(() => {
    setQueryParams({
      name: filter.name,
      cityId: filter.cityId,
    });
  }, [filter]);

  return { filter, initialFilter, setFilter };
};

export default useOfficesFilter; 